import createModule from "../createModule"
import moment from "moment"
import view from "./view"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getFilteredData, getCategoryItemsSubset, getPerformanceAttribution } from "./selectors/data"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getModelEarliestDate } from "modules/security-profile/selectors/dates"
import { computePositionSet } from "modules/security-profile/helpers/security"
import { getMaxFactors } from "./selectors/performance"
import { getOptions } from "./selectors/options"
import { getDisplayType } from "./selectors/items"
import { getDetails } from "./selectors/details"
import { Creators } from "./model"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    modelEarliestDate: getModelEarliestDate(state),
  }),
  data: [{
    resource: "securityPerformanceHistory",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, startDate, endDate, modelEarliestDate }) => {
      // Start the position set in the past to make sure the date is available on the previous modeled date
      // We go one week in the past so we don't have to query the previous date
      let positionSetDate = moment(startDate).add(-1, "week").format("YYYY-MM-DD")
      // We never go earlier than the model start
      if (positionSetDate < modelEarliestDate) {
        positionSetDate = modelEarliestDate
      }

      if (base) {
        if (!base.type) {
          base = {
            dates: [{
              date: positionSetDate,
              ...base,
            }],
          }
        }
      }

      return {
        id: `securityPerformanceHistory-${modelId}${ticker}${mic}${startDate}${endDate}${JSON.stringify(base)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $startDate: Date!, $endDate: Date!) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $startDate, to: $endDate, interval: AUTO) {
              performance {
                date,
                totalReturn {
                  cumulativePercent
                }
                attribution {
                  summary {
                    factors {
                      cumulativePercent
                    }
                    specific {
                      cumulativePercent
                    }
                    trading {
                      cumulativePercent
                    }
                  }
                  factors {
                    id
                    category
                    name
                    return {
                      cumulativePercent
                    }
                  }
                }
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet: {
            dates: [{
              date: positionSetDate,
              ...computePositionSet(assetClass, ticker, mic, modelProviderId),
            }],
          },
          base,
          startDate,
          endDate,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    ...state.modules.securityProfilePerformance,
    earliestDate: getEarliestDate(state, props),
    latestDate: getLatestDate(state, props),
    date: getSelectedDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    displayType: getDisplayType(state),
    options: getOptions(state),
    details: getDetails(state),
    performanceAttribution: getPerformanceAttribution(state, props),
    maxFactors: getMaxFactors(state, props),
  }),
  actions: {
    setDate: PortfolioRootCreators.setProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
    ...Creators,
  },
})
